import React from "react";
import UploadXlsx from "../../../views/Config/settings/uploadXlsx";
const UploadFile = ({ processName, title, ...rest }) => (
  <UploadXlsx processName={processName} title={title} {...rest} />
);

export default UploadFile;
